import React, { useState } from 'react';
import { connect } from 'redux-zero/react';
import { useAsync } from 'react-use';
import { NavLink } from 'react-router-dom';
import useReactRouter from 'use-react-router';
import { combineActions } from 'redux-zero/utils';
import { isNumber /*, get*/, has } from 'lodash';
import {
  DsBadge,
  DsIcon,
  DsTokenSelector,
  DsUserMenu,
} from '@tokenyico/design-system/dist/reactJS';

import { formActions, holderActions } from 'app/state/actions';
import { getInvestorName } from 'app/helpers/investor';
import { HolderService /*, MessageService*/ } from 'services';
import { useTranslation } from 'react-i18next';
import { AuthenticationService } from 'services';

import placeholderImage from 'assets/images/placeholder.png';
import logo from 'assets/themes/default/logo.png';

const getIcon = (name) => {
  const svgName = name
    .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2')
    .toLowerCase()
    .replace('-icon-', '');

  try {
    return <DsIcon size="14px" name={svgName} />;
  } catch (e) {
    // do not display error to user but do log error
    // TODO logger module for app
    console.error('token link Navigation icon not found for' + svgName);
  }
};

const NavBar = ({
  user,
  setError,
  tokens,
  selectedToken,
  setSelectedToken,
  resetUser,
  // setMessages,
  // unseenMessages,
  pendingRequests,
}) => {
  const { t } = useTranslation();
  const { history } = useReactRouter();
  const [tokenLinks, setTokenLinks] = useState([]);

  useAsync(async () => {
    try {
      if (selectedToken) setTokenLinks(await HolderService.getTokenLinks(selectedToken.id));
    } catch (error) {
      setError(error);
    }
  });

  const onClickSignOut = async () => {
    try {
      await AuthenticationService.signOut();
      resetUser();
    } catch (error) {
      setError(error);
    }
    setTimeout(history.push('/'), 100);
  };

  const changeToken = async (token) => {
    // await getMessages(token);
    setSelectedToken(token);
    history.push('/dashboard');
  };

  /*
  const getMessages = async (selectedToken) => {
    try {
      MessageService.getAllMessages(get(selectedToken, 'address')).then(setMessages);
    } catch (error) {
      console.error(error);
    }
  };
  */

  tokens.forEach((token) => {
    if (!token.image) {
      token.image = placeholderImage;
    }
  });

  if (!selectedToken.image) {
    selectedToken.image = placeholderImage;
  }

  return (
    <>
      <header className="_p:x(2) _p:bottom(1)">
        <div className="_grid _flex:row _flex:justify(space-between) _p:x(4) _p:bottom(2)">
          <div className="_col(4) _m:bottom(0) _flex:align(center)">
            <img src={logo} alt="logo" className="_p:right(2)" />
          </div>
          <div className="_col(8) _m:bottom(0) _flex:justify(end)">
            <div>
              {tokens && tokens.length > 1 && (
                // delete dummy status data when end point supplies token status
                <DsTokenSelector
                  tokens={tokens.map((token) => {
                    if (!token.hasOwnProperty('status')) return { ...token, status: 'DEPLOYED' };
                    return token;
                  })}
                  selectedToken={
                    !selectedToken.hasOwnProperty('status')
                      ? { ...selectedToken, status: 'DEPLOYED' }
                      : selectedToken
                  }
                  onSelectToken={({ detail }) => changeToken(detail)}
                />
              )}
            </div>
            <div className="_m:left(3)">
              <DsUserMenu
                onSignOut={() => onClickSignOut()}
                name={getInvestorName(user)}
                wallet={user.identityAddress || ''}
                email={user.email}
              >
                <NavLink exact to="/profile" className="_text:sm _text-grey-900 _m:x(3)">
                  <DsIcon size="11px" name="profile" className="_m:right(1)" />
                  <span className="_text-grey-900 _m:x(3)">&nbsp;Profile</span>
                </NavLink>
              </DsUserMenu>
            </div>
          </div>
        </div>
        <div className="_grid _p:x(4) " style={{ borderTop: '1px solid var(--grey-400)' }}>
          <nav className="_col(12) _nogutter">
            <ul className="nav-grid _text:sm">
              <li>
                <NavLink exact to="/dashboard">
                  <DsIcon size="14px" name="dashboard" />
                  Dashboard
                </NavLink>
              </li>
              <li>
                <NavLink exact to="/transactions">
                  <DsIcon size="14px" name="exchange" />
                  Transactions
                </NavLink>
              </li>
              <li>
                <NavLink to="/orders">
                  <DsIcon size="14px" name="cart" />
                  Orders
                </NavLink>
              </li>
              <li>
                <NavLink exact to="/requests">
                  <DsIcon size="14px" name="request" />
                  {isNumber(pendingRequests) && pendingRequests > 0 ? (
                    <DsBadge isDot hasShadow version="warning">
                      {t('shared.requests')}
                    </DsBadge>
                  ) : (
                    t('shared.requests')
                  )}
                </NavLink>
              </li>
              {/* <li className="disabled">
                <NavLink
                  onClick={(e) => {
                    e.preventDefault(); // disable Navlink redirection hack
                  }}
                  exact
                  to="/messages"
                >
                  <DsTooltip text={t('shared.disableMessagesHelper')} isVisibleOnHover>
                    <DsIcon size="14px" name="message" className="_p:right(1)" />
                    {isNumber(unseenMessages) && unseenMessages > 0 ? (
                      <DsBadge isDot hasShadow>
                        {t('shared.messages')}
                      </DsBadge>
                    ) : (
                      t('shared.messages')
                    )}
                  </DsTooltip>
                </NavLink>
              </li> */}

              {selectedToken && (selectedToken.tradable || selectedToken.cexTradable) && (
                <li>
                  <NavLink exact activeClassName="active _text(500)" to="/billboard">
                    <DsIcon size="14px" name="transfer" className="_p:right(1)" />
                    {t('shared.buyOrSell')}
                  </NavLink>
                </li>
              )}

              {tokenLinks &&
                tokenLinks.map((item, index) => (
                  <li key={index++}>
                    <a
                      rel="noopener noreferrer"
                      target={item.opensInNewTab ? '_blank' : null}
                      href={item.url}
                    >
                      {getIcon(item.iconName)}
                      &nbsp;{item.name}
                    </a>
                  </li>
                ))}
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

const mapToProps = ({
  setSelectedToken,
  holder: { user, tokens, selectedToken, setMessages, messages, pendingRequests },
}) => ({
  user,
  tokens,
  selectedToken,
  setSelectedToken,
  pendingRequests,
  setMessages,
  unseenMessages: messages.filter((m) => has(m, 'unseen')).length,
});

export default connect(mapToProps, combineActions(formActions, holderActions))(NavBar);
